export const SET_CUSTOMER = "SET_CUSTOMER";
export const GET_CUSTOMER = "GET_CUSTOMER";